import {ReactNode} from "react";

const DropdownHeader = ({children}: {children: ReactNode}) => {
  return <h6 className="dropdown-header">{children}</h6>;
};

DropdownHeader.displayName = "DropdownHeader";
export {DropdownHeader};
